import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5553ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-call-footer" }
const _hoisted_2 = {
  key: 0,
  class: "service-buttons"
}
const _hoisted_3 = { class: "select-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "call-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_DropdownList = _resolveComponent("DropdownList")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_TransferCallList = _resolveComponent("TransferCallList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.settingsState.minimize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SplitButton, { class: "button" }, {
            "first-side": _withCtx(() => [
              _createVNode(_component_Button, {
                class: "button-left",
                size: "l",
                iconOnly: "",
                mode: "outlined",
                icon: {name: `${_ctx.settingsState.mute ?  'ic24-mic-off' : 'ic24-mic'}`, color: _ctx.getIconColor(_ctx.isCallPaused || _ctx.isCallProgressing)},
                disabled: _ctx.isCallPaused || _ctx.isCallProgressing,
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.changeMute(!_ctx.settingsState.mute);})
              }, null, 8, ["icon", "disabled"])
            ]),
            "last-side": _withCtx(() => [
              _createVNode(_component_Button, {
                class: "button-right",
                size: "l",
                mode: "outlined",
                iconOnly: "",
                ref: "selectMics",
                disabled: _ctx.isCallPaused || _ctx.isCallProgressing,
                icon: { name: 'ic12-arrow-down', width: '12px', height: '12px'},
                onClick: _ctx.onOpenListMics
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.isOpenMicList)
                ? (_openBlock(), _createBlock(_component_DropdownList, {
                    key: 0,
                    class: "mic-list"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settingsState.audioDevices, ({ name, id }) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["list-item", {'active': _ctx.isAudioActive(id)}]),
                            key: id,
                            onClick: ($event: any) => (_ctx.setActiveAudioDevice(name, id))
                          }, _toDisplayString(name), 11, _hoisted_4))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Hint, {
            class: "button",
            text: _ctx.calls.length > 48 ? _ctx.t('hintForDisabled') : ''
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                mode: "outlined",
                disabled: _ctx.isCallProgressing,
                icon: { spriteUrl: 'static/icons-pack.svg', name: 'ic24-phone-new' },
                size: "l",
                iconOnly: "",
                onClick: _ctx.makeNewCall
              }, null, 8, ["disabled", "icon", "onClick"])
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(_component_Button, {
            class: "button",
            mode: "outlined",
            size: "l",
            disabled: _ctx.isCallPaused || _ctx.isCallProgressing,
            icon: {name: 'ic20-numbers', width: '20px', height: '20px'},
            iconOnly: "",
            onClick: _ctx.switchNumpad
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            class: "button",
            mode: "outlined",
            size: "l",
            disabled: !_ctx.canCurrentCallToggleActive || _ctx.isCallProgressing,
            icon: _ctx.selectCall?.active ? 'ic24-pause' : 'ic24-play',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.canCurrentCallToggleActive && _ctx.toggleCallStatus()))
          }, null, 8, ["disabled", "icon"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "call-button button-end",
        mode: "alert",
        iconOnly: _ctx.settingsState.minimize,
        icon: {name: 'ic20-phone-missed', color: '--sui-white'},
        onClick: _cache[2] || (_cache[2] = () => _ctx.hangUp({ id: _ctx.selectCall?.id }))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.settingsState.minimize ? '' : _ctx.t('buttons.end')), 1)
        ]),
        _: 1
      }, 8, ["iconOnly"]),
      (_ctx.showAdditionalButton)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "call-button",
            mode: "flat",
            ref: "selectCalls",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenTransferSelect()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('buttons.transfer')), 1),
              _createVNode(_component_Icon, {
                class: _normalizeClass(["icon-transfer", {'transform': _ctx.isOpenTransferSelect}]),
                name: "ic12-arrow-down",
                color: "--sui-purple-500",
                width: "12",
                height: "12"
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.isOpenTransferSelect)
            ? (_openBlock(), _createBlock(_component_TransferCallList, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}